import React from 'react';
import './index.less';
import { Row, Col } from 'antd';

export interface IABSScaleContainerProps {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  middleContent?: React.ReactNode;
  leftSpan?: number;
  rightSpan?: number;
  middleSpan?: number;
  className?: string;
}
 
class ABSScaleContainer extends React.Component<IABSScaleContainerProps> {
  defaultSpan: number = 12;

  renderCol(content?: React.ReactNode, span?: number) {
    const spanNew = span ? span : this.defaultSpan;
    if (content) {
      return <Col span={spanNew} className="abs-double-container-col">{content}</Col>;
    }
    return '';
  }

  render() { 
    const { leftContent, rightContent, middleContent,
      leftSpan, rightSpan, middleSpan, className,
    } = this.props;
    if (middleContent) {
      this.defaultSpan = 8;
    }
    const classs = `abs-double-container ${className}`;
    return (
      <Row className={classs}>
        {this.renderCol(leftContent, leftSpan)}
        {this.renderCol(middleContent, middleSpan)}
        {this.renderCol(rightContent, rightSpan)}
      </Row>
    );
  }
}
 
export default ABSScaleContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSScaleContainer/index.tsx